import {createAction} from 'redux-actions';
import {
    getQcToolsMetadata,
    updateQcToolsMetadataGeneral,
    updateLocalizedMetadata,
    updateTerritorialMetadata,
} from '@pluto/rest';
import {curry} from 'ramda';
import {DispatchAny} from '@pluto/@types';
import tryToCatch from 'try-to-catch';

import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';

export const QC_TOOLS_METADATA_SET = 'QC_TOOLS_METADATA_SET';
export const QC_TOOLS_METADATA_RESET = 'QC_TOOLS_METADATA_RESET';

export const setQcToolsMetadataAction = createAction<Promise<any>, number>(
    QC_TOOLS_METADATA_SET,
    async (id: number) => {
        return await getQcToolsMetadata(id);
    }
);

export const setQcToolsMetadataGeneral = curry(
    async (id: number, params: any, dispatch: DispatchAny) => {
        const response = await updateQcToolsMetadataGeneral(id, params);

        if (response.statusText === 'OK') {
            dispatch(setQcToolsMetadataAction(id));
        }
    }
);

export const updateLocalizedMetadataAction = curry(async (params, dispatch) => {
    const {body, id} = params;

    const [error] = await tryToCatch(updateLocalizedMetadata, {
        body,
        id,
    });

    if (!error) {
        dispatch(
            setNotification({
                type: 'success',
                text: 'Metadata successfully updated',
            })
        );
        dispatch(setQcToolsMetadataAction(id));
    } else {
        const {data: errorData} = error.response;

        dispatch(
            setNotification({
                type: 'error',
                text: errorData.message,
            })
        );
    }
});

export const updateTerritorialMetadataAction = curry(async (params, dispatch) => {
    const {body, id} = params;

    const [error] = await tryToCatch(updateTerritorialMetadata, {
        body,
        id,
    });

    if (!error) {
        dispatch(
            setNotification({
                type: 'success',
                text: 'Metadata successfully updated',
            })
        );
        dispatch(setQcToolsMetadataAction(id));
    } else {
        const {data: errorData} = error.response;
        dispatch(
            setNotification({
                type: 'error',
                text: errorData.message,
            })
        );
    }
});

export const resetQcToolsMetadataAction = createAction(QC_TOOLS_METADATA_RESET);
